import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { toQueryParams } from "../utils/http.util";
import { PublicConfigService } from "./public.config.service";

@Injectable()
export class DashboardService {

  constructor(private httpClient: HttpClient, private publicConfigService: PublicConfigService) {

  }

  getDashboardConfig(roleId: string) {
    return this.httpClient.get(`${this.publicConfigService.rpBaseUrl}/api/dashboard-config`, {
      params: toQueryParams({roleId: roleId})
    });
  }

  saveDashboardConfig(roleId: string, dashboardConfig: string) {
    return this.httpClient.post(`${this.publicConfigService.rpBaseUrl}/api/dashboard-config`, {
      roleId: roleId,
      value: dashboardConfig
    });
  }
}
